export default __webpack_public_path__ + "static/media/onRampLogo.4e9c5156.svg";